import { Image, H4, H6, P } from '../../../../AbstractElements';
import { JohanDeo, JohanDeoMailId, ProjectDescription, ProjectDescriptionDetails } from '../../../../Constant';
import { Col, Media, Row } from 'reactstrap';
import React, { Fragment } from 'react';
import user1 from '../../../../assets/images/user/1.jpg';

const InvoiceDescription = ({rowData, data}) => {

  
  return (
    <Fragment>
      {/* <Row className='invo-profile'> */}
      {/* <div className='d-flex justify-content-between'></div> */}
        <div className='d-flex justify-content-between'>
        {/* <Col> */}
          <div className='invo-profile-left'>
            <Media>
              {/* <div className='media-left'>
                <Image attrImage={{ className: 'media-object rounded-circle img-60', src: `${user1}`, alt: '' }} />
              </div> */}
              <Media body className=''>
                <H4 attrH4={{ className: 'media-heading f-w-600' }}>{`${data.first_name} ${data.surname}`}</H4>
                <P>
                  <span className='digits'>{data.phone}</span>
                  <br />
                  {data.email? data.email : "Email: N/A"}
                </P>
              </Media>
            </Media>
          </div>
        {/* </Col> */}
        {/* <Col> */}
        {/* <Col> */}
          <div className='text-md-end'>
            <div id='project'>
              <H6>{"Patient ID"}</H6>
              <P>{data.patient_reg_no}</P>
            </div>
          </div>
        {/* </Col> */}
        </div>
      {/* </Row> */}
    </Fragment>
  );
};
export default InvoiceDescription;
